import DocumentTemplate from '@/models/DocumentTemplate';

const GET_DOCUMENT_TEMPLATES = 'get_document_templates';
const GET_DOCUMENT_TEMPLATES_REQUEST = GET_DOCUMENT_TEMPLATES + '_request';
const GET_DOCUMENT_TEMPLATES_SUCCESS = GET_DOCUMENT_TEMPLATES + '_success';
const GET_DOCUMENT_TEMPLATES_ERROR = GET_DOCUMENT_TEMPLATES + '_error';

export { GET_DOCUMENT_TEMPLATES };

export default {
    state: {
        templates: [],
        loading: false,
        templatesErrors: [],
        templatesMeta: {},
    },
    mutations: {
        [GET_DOCUMENT_TEMPLATES_REQUEST]: (state) => {
            state.templates = [];
            state.loading = true;
            state.templatesErrors = [];
            state.templatesMeta = {};
        },
        [GET_DOCUMENT_TEMPLATES_SUCCESS]: (state, { templates, meta }) => {
            state.templates = templates;
            state.loading = false;
            state.templatesErrors = [];
            state.templatesMeta = meta;
        },
        [GET_DOCUMENT_TEMPLATES_ERROR]: (state, { errors }) => {
            state.templates = [];
            state.loading = false;
            state.templatesErrors = errors;
            state.templatesMeta = {};
        },
    },
    actions: {
        [GET_DOCUMENT_TEMPLATES]: ({ commit, state }, { params = {} }) => {
            commit(GET_DOCUMENT_TEMPLATES_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.templatesMeta.current_page) {
                        params.page = state.templatesMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                DocumentTemplate.collection(params)
                    .then(({items, meta}) => {
                        const templates = items;
                        commit(GET_DOCUMENT_TEMPLATES_SUCCESS, { templates, meta });
                        resolve(templates);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_DOCUMENT_TEMPLATES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/document-templates.js